<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">客流区域阈值设置</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
           <el-form-item label="区域名称">
            <el-select v-model="RegionId" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in EqRegionArr"
                :key="item.RegionId"
                :label="item.RegionName"
                :value="item.RegionId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="RegionName" label="区域名称"></el-table-column>
              <el-table-column prop="WarmThreshold" label="报警阈值"></el-table-column>
              <el-table-column prop="Threshold" label="预警阈值"></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >查看</el-button>
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >编辑</el-button>
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >删除</el-button>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "RegionThresholdConfigView",
  controller: "UI",
  action: "RegionThresholdConfigView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      RegionId: "",
      EqRegionArr: [],
    };
  },
  mounted: function() {
    //所属区域
    this.getRegionInfo();
    this.search();
  },
  methods: {
     getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionList()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          this.EqRegionArr = r;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    search() {
      let searchInfo = {
        RegionId: this.RegionId,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      new MyApis.RegionThresholdApi()
        .GetItemPagingList(searchInfo)
        .then(r => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/dataDetection/UI/RegionThresholdConfigEdit",
        query: {
          type: "add"
        }
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/dataDetection/ui/RegionThresholdConfigEdit",
        query: { InfoId: row.Id, type: "query" }
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/dataDetection/ui/RegionThresholdConfigEdit",
        query: { InfoId: row.Id, type: "edit" }
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          new MyApis.RegionThresholdApi()
            .DelItem(row)
            .then(r => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!"
                });
              }
              this.search();
            })
            .catch(e => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      if (new Date(this.EndTime) < new Date(this.BeginTime)) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.RegionId = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    }
  }
};
</script>
